module.exports = __webpack_public_path__ + "static/media/6_H.28edc101.jpg";